import signedFetch from '../util/signedFetch.js';

export default searchTerm =>
  signedFetch(
    'searchUsers',
    `${__API_BASE__}/user/search?searchTerm=${encodeURIComponent(searchTerm.trim())}`,
    'GET',
    undefined
  );
